import { either } from "fp-ts/lib";
import { pipe } from "fp-ts/lib/function";
import { union } from "../../shared/src/codecs/types/union";
import { literal } from "../../shared/src/codecs/types/literal";
import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import * as util from "../../shared/src/util";

export const ListingReasonForSale1 = union([
    literal("unknown"),
    literal("owner_initiated"),
    literal("repossession"),
    literal("probate"),
    literal("divorce"),
]);
export type TListingReasonForSale1 = TTypeOfCodec<typeof ListingReasonForSale1>;

// Sail Valuations' own enum is
// SALE | PROBATE | DIVORCE | RELOCATION | DOWNSIZING | UPSIZING | EQUITY_RELEASE | OTHER,
// so `unknown` has no honest counterpart and omits the field rather than asserting OTHER.
//
// Exhaustive on purpose: a sixth listing reason must not be able to reach SV as a
// silently absent field, which is what a `string` ternary chain would have allowed.
const valReasonForSale = (reason: TListingReasonForSale1): string | undefined =>
    reason === "probate" ? "PROBATE"
    : reason === "divorce" ? "DIVORCE"
    : reason === "owner_initiated" ? "SALE"
    : reason === "repossession" ? "OTHER"
    : reason === "unknown" ? undefined
    : util.requireExhaustive(reason);

export const ListingReasonForSale1_ValReasonForSale = (reason: string | null | undefined): string | undefined =>
    pipe(
        ListingReasonForSale1.decode(reason),
        either.fold(
            () => undefined,
            valReasonForSale,
        ),
    );
